namespace TabAurous.Inventory {
    export interface SetMasterRow {
        Id?: number;
        SKU?: string;
        ItemDetails?: SetItemsRow[];
    }

    export namespace SetMasterRow {
        export const idProperty = 'Id';
        export const nameProperty = 'SKU';
        export const localTextPrefix = 'Inventory.SetMaster';
        export const deletePermission = 'Inventory:Set:Delete';
        export const insertPermission = 'Inventory:Set:Add';
        export const readPermission = '*';
        export const updatePermission = 'Inventory:Set:Edit';

        export declare const enum Fields {
            Id = "Id",
            SKU = "SKU",
            ItemDetails = "ItemDetails"
        }
    }
}
